import { useState } from 'react';
import { hotComments } from '@/mocks/homeNews';
import SectionHeading from './SectionHeading';

const toneStyles: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  secondary: 'bg-secondary-100 text-secondary-900',
  accent: 'bg-accent-100 text-accent-900',
};

export default function HotComments() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section id="comments" className="w-full bg-background-100 border-y border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <SectionHeading
          kicker="Hot Discussion"
          title="热议广场"
          desc="同一件事，有人等反转、有人翻时间线、有人已经离场。这里汇聚评论热度最高的几种声音。"
          action={
            <div className="flex items-center gap-2 text-[12px] text-foreground-600 w-fit">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
              近 24 小时 12,486 条评论
            </div>
          }
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {hotComments.map((comment) => {
            const isLiked = Boolean(liked[comment.id]);
            return (
              <article
                key={comment.id}
                className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
              >
                <div className="flex items-start gap-3">
                  <span
                    className={`flex items-center justify-center w-10 h-10 rounded-full font-heading font-bold text-[16px] shrink-0 ${
                      toneStyles[comment.tone] ?? toneStyles.secondary
                    }`}
                  >
                    {comment.initial}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="text-[14px] font-semibold text-foreground-950">
                        {comment.user}
                      </span>
                      <span className="text-[12px] text-foreground-400">{comment.time}</span>
                    </div>
                    <p className="mt-2 text-[14px] leading-relaxed text-foreground-700">
                      {comment.content}
                    </p>
                    <a
                      href="#trending"
                      className="mt-3 inline-flex items-center gap-1.5 text-[11px] font-medium text-primary-700 bg-primary-50 px-2.5 py-1 rounded-full hover:bg-primary-100 transition-colors"
                    >
                      <span className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-link text-[11px]" />
                      </span>
                      {comment.story}
                    </a>
                    <div className="mt-4 flex items-center gap-5 text-[12px]">
                      <button
                        type="button"
                        onClick={() => toggleLike(comment.id)}
                        className={`flex items-center gap-1.5 transition-colors ${
                          isLiked ? 'text-primary-600' : 'text-foreground-500 hover:text-foreground-800'
                        }`}
                      >
                        <span className="w-4 h-4 flex items-center justify-center">
                          <i
                            className={`${
                              isLiked ? 'ri-heart-3-fill' : 'ri-heart-3-line'
                            } text-[15px]`}
                          />
                        </span>
                        {comment.likes + (isLiked ? 1 : 0)}
                      </button>
                      <button
                        type="button"
                        className="flex items-center gap-1.5 text-foreground-500 hover:text-foreground-800 transition-colors"
                      >
                        <span className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-chat-3-line text-[15px]" />
                        </span>
                        {comment.replies}
                      </button>
                      <button
                        type="button"
                        className="flex items-center gap-1.5 text-foreground-500 hover:text-foreground-800 transition-colors ml-auto"
                      >
                        <span className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-share-forward-line text-[15px]" />
                        </span>
                        转发
                      </button>
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        <div className="mt-6 flex justify-center">
          <button
            type="button"
            className="inline-flex items-center gap-2 border border-background-300 bg-background-50 text-foreground-800 text-[13px] font-medium px-6 py-2.5 rounded-md hover:bg-background-200 transition-colors whitespace-nowrap"
          >
            加载更多评论
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-down-line text-[15px]" />
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}